var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgDelete = function SvgImgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M17.616 7.445a.75.75 0 1 0-1.06-1.061L12 10.939 7.445 6.384a.75.75 0 0 0-1.061 1.06L10.939 12l-4.555 4.555a.75.75 0 0 0 1.06 1.061L12 13.061l4.555 4.555a.75.75 0 0 0 1.061-1.06L13.061 12z",
    clipRule: "evenodd"
  })));
};
export default SvgImgDelete;